import { render } from "./LicensePageHeader.vue?vue&type=template&id=7da3425f"
import script from "./LicensePageHeader.vue?vue&type=script&lang=js"
export * from "./LicensePageHeader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__